import Grid from '@mui/material/Grid2';

/**
 * SectionTabs Component
 *
 * This component renders a list of tab-like elements that users can click to navigate between sections.
 * Each tab represents an item from the `data` array, displaying the title and applying custom styles
 * based on the selected section. Each item also includes custom content to display for each tab.
 *
 * @param {Object} props - The component props.
 * @param {string} props.selectedSection - The code of the currently selected tab, used to apply active styling.
 * @param {Array<{ code: string, title: string, content: JSX.Element, callback: Function }>} props.data - An array of tab data.
 *  Each item should contain:
 *    - `code`: A unique identifier for the tab.
 *    - `title`: The display text for the tab.
 *    - `content`: The custom JSX content displayed for each tab.
 *    - `callback`: The function to be called when the tab is clicked.
 * @param {boolean} props.display - Determines whether to display the tabs container or not.
 *
 * El ancho de cada pestana se reparte entre las 12 columnas segun cuantas haya,
 * porque el numero de secciones depende del tenant.
 *
 * @returns {JSX.Element} The rendered SectionTabs component.
 */
const SectionTabs = ({ selectedSection, data, display }) => {

  return (
    <>
      {display && (
        <div className="dyTheme1 dyBorder1 reportsTable">
          <Grid
            alignItems="center"
            columns={12}
            container
            justifyContent="center"
            spacing={4}
            style={{ padding: '0 8%' }}
          >
            {data.map((element) => (
              <Grid
                key={element.code}
                alignItems="center"
                className={
                  selectedSection === element.code 
                    ? 'selected-exportable-tab tab' 
                    : 'tab'
                }
                display="flex"
                justifyContent="center"
                onClick={element.callback}
                size={{ xs: 6, md: 12 / data.length }}
              >
                {element.title}
              </Grid>
            ))}
          </Grid>
        </div>
      )}
    </>
  );
};

export default SectionTabs;
